import { Share, Plus } from "lucide-react";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription,
} from "@/components/ui/sheet";
import { PWA } from "@/constants/testIds/pwa";

const STEPS = [
  { icon: Share, text: "Toca em Compartilhar (quadradinho com a seta) na barra do Safari." },
  { icon: Plus, text: "Rola e toca em Adicionar à Tela de Início. Aí eu fico aqui com você, tipo app de verdade." },
];

export default function PwaIosSheet({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        data-testid={PWA.iosSheet}
        className="bg-brand-surface border-brand-line rounded-t-3xl"
      >
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl text-brand-ink">
            Me coloca na tela inicial
          </SheetTitle>
          <SheetDescription className="text-brand-ink2 text-[13.5px] font-ui">
            No iPhone o Safari não instala sozinho — são 2 toques:
          </SheetDescription>
        </SheetHeader>
        <ol className="mt-5 space-y-3">
          {STEPS.map((s, i) => (
            <li key={s.text} className="flex items-start gap-3">
              <span className="shrink-0 w-9 h-9 rounded-xl bg-brand-elevated text-brand-rose flex items-center justify-center">
                <s.icon className="w-4 h-4" />
              </span>
              <p className="text-[14px] text-brand-ink font-ui pt-1.5">
                <span className="text-brand-rose mr-1">{i + 1}.</span>
                {s.text}
              </p>
            </li>
          ))}
        </ol>
        <button
          type="button"
          data-testid={PWA.iosClose}
          onClick={() => onOpenChange(false)}
          className="mt-6 w-full min-h-[44px] rounded-full bg-brand-rose hover:bg-brand-roseHover text-white text-[14px] font-ui"
        >
          Entendi
        </button>
      </SheetContent>
    </Sheet>
  );
}
